import * as React from "react";
import noop from "lodash/noop";
import defer from "lodash/defer";
import { inject } from "mobx-react";
import { reaction } from "mobx";
import PropTypes from "prop-types";

import Utils from "pages/common/lib/grabyo-util";

import TimelineContainer from "./timelineContainer";

class Timeline extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount() {
        const {
            composition: { sections, assets }
        } = this.props;

        this.props.renderCallback(this.ref.current);

        this.currentSections = sections.map((section) => section.id);
        this.currentAssets = Utils.mapToArray(assets).map((asset) => asset.id);

        this.onNewSectionDisposer = reaction(
            () => this.props.composition.sections.length,
            () => this.onSectionsLengthChange()
        );
    }
    /**
     * @summary - Called when amt of sections in a composition changes
     * @method
     *
     */
    onSectionsLengthChange = () => {
        const {
            composition: { sections }
        } = this.props;

        if (sections.length > this.currentSections.length) {
            sections.forEach((section) => {
                if (!this.currentSections.includes(section.id)) {
                    this.onNewSection(section);
                }
            });
        }

        this.currentSections = sections.map((section) => section.id);
    };

    /**
     * @summary - If there is a new section we want to seek to it and make it active
     * NOTE: Defer is important. It prevents these UI actions from being added to undo history
     * @method
     *
     * @param {SectionStore} section
     */
    onNewSection = (section) =>
        defer(() => {
            const { ui, player } = this.props;
            ui.setNewSection(section.id);
            ui.setActiveSection(section.id);
            if (player) {
                player.seek(section.startTime);
            }
        });

    componentWillUnmount() {
        this.onNewSectionDisposer();
    }

    render() {
        return (
            <div ref={this.ref} style={{ position: `relative` }}>
                <TimelineContainer />
            </div>
        );
    }
}

Timeline.propTypes = {
    renderCallback: PropTypes.func,
    player: PropTypes.object
};

Timeline.defaultProps = {
    renderCallback: noop
};

export default inject(({ composition, ui }) => ({ composition, ui }))(Timeline);
